/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import BaseEditorComponent from 'cio/components/condition-list/edit/base';
import serialize from 'cio/utils/conditions/serialize/relationship';

export default class ConditionListEditRelationshipComponent extends BaseEditorComponent {
  @service environment;

  // external API
  variation = null;
  disabled = false;
  condition = null;
  campaign = null;
  allowBlankName = true;
  allowJsonOperators = false;
  onApply() {}

  @computed('condition.typeId')
  get errors() {
    let errors = [];

    if (this.condition.typeId === null) {
      errors.push("Object type can't be blank.");
    }

    return errors;
  }

  @action
  _onApply() {
    let condition = serialize(this.condition);

    return this.onApply(condition);
  }
}
